import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import _values from "lodash/values";
import _findIndex from "lodash/findIndex";
import _includes from "lodash/includes";
import _isEmpty from "lodash/isEmpty";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import PropTypes from 'prop-types';
import classes from '@nerdwallet/base-styles/classes';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import Tabs from '@nerdwallet/react-tabs';
import { CONTENT_TABS, TRK_PRODUCT_LOCATION } from './lib/constants';
import { sanitizeNode } from './lib/utils';
import ExpandableContent from './expandable-content';
import OptionalListContent from './optional-list-content';
import { TabContentImpression } from './tab-content';
import TabImpression from './tab-impression';

var Content = function Content(_ref) {
  var activeContentTab = _ref.activeContentTab,
      analytics = _ref.analytics,
      bottomLine = _ref.bottomLine,
      className = _ref.className,
      cons = _ref.cons,
      enableAnalytics = _ref.enableAnalytics,
      id = _ref.id,
      initTabContentExpanded = _ref.initTabContentExpanded,
      keyFacts = _ref.keyFacts,
      marketplaceEntity = _ref.marketplaceEntity,
      omitExpandFunctionalityOnMobile = _ref.omitExpandFunctionalityOnMobile,
      omittedTabs = _ref.omittedTabs,
      parentImpressionId = _ref.parentImpressionId,
      productDetails = _ref.productDetails,
      pros = _ref.pros,
      reviewLinkTabIndex = _ref.reviewLinkTabIndex,
      taxonomy = _ref.taxonomy,
      trkPageType = _ref.trkPageType,
      trkSectionCategory = _ref.trkSectionCategory,
      trkSectionPosition = _ref.trkSectionPosition;
  useDeprecatedPropsWarning({
    component: 'Content',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }, {
      version: '6.9.0',
      deprecated: 'parentImpressionId',
      migration: 'No longer used. It is retrieved with react context.'
    }],
    props: {
      enableAnalytics: enableAnalytics,
      parentImpressionId: parentImpressionId
    }
  });
  var hasPros = !_isEmpty(pros);
  var hasCons = !_isEmpty(cons);
  var prosContent = /*#__PURE__*/React.createElement(OptionalListContent, {
    content: pros,
    contentLabel: "Pros",
    className: classes(['flex-1', {
      'padding-right-3--wide': hasCons
    }]),
    useLiPadding: true
  });
  var consContent = /*#__PURE__*/React.createElement(OptionalListContent, {
    content: cons,
    contentLabel: "Cons",
    className: classes(['flex-1', 'margin-top-0--wide', {
      'padding-left-3--wide': hasPros,
      'margin-top-3': hasPros
    }]),
    useLiPadding: true
  });
  var prosCons = /*#__PURE__*/React.createElement("div", {
    className: classes('display-flex--wide')
  }, prosContent, consContent);
  var tabs = [{
    id: CONTENT_TABS.WHY_WE_LIKE_IT,
    content: !!bottomLine && bottomLine,
    label: 'Why We Like It'
  }, {
    id: CONTENT_TABS.PROS_CONS,
    content: (hasPros || hasCons) && prosCons,
    label: 'Pros & Cons'
  }, {
    id: CONTENT_TABS.PRODUCT_DETAILS,
    content: !!productDetails && productDetails,
    label: 'Product Details'
  }, {
    id: CONTENT_TABS.KEY_FACTS,
    content: !!keyFacts && keyFacts,
    label: 'Key Facts'
  }].filter(function (tab) {
    return !!tab.content && !_includes(omittedTabs, tab.id);
  }); // Calculate, mark initially open tab (if it exists), & move it to the front.

  if (_isEmpty(tabs)) {
    return null;
  }

  var activeTabIndex = _findIndex(tabs, function (tab) {
    return tab.id === activeContentTab;
  });

  var initialActiveTabIndex = activeTabIndex >= 0 ? activeTabIndex : 0;
  var initialTab = tabs[initialActiveTabIndex];
  initialTab.initialActiveTab = true;
  var reorderedTabs = initialActiveTabIndex ? [initialTab].concat(_toConsumableArray(tabs.filter(function (_unused, i) {
    return initialActiveTabIndex !== i;
  }))) : tabs; // negative value for reviewLinkTabIndex indicates no tab should have review link

  if (reviewLinkTabIndex >= 0) {
    // if filtered tabs is shorter than reviewLinkTabIndex put review link in the last tab
    var computedReviewLinkTabIndex = Math.min(tabs.length - 1, reviewLinkTabIndex);
    var reviewLinkTab = reorderedTabs[computedReviewLinkTabIndex];
    reviewLinkTab.hasReviewLink = true;
  }

  return /*#__PURE__*/React.createElement(Tabs, {
    id: "".concat(TRK_PRODUCT_LOCATION, "__tabs--").concat(id),
    className: className
  }, reorderedTabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(TabImpression, {
      key: tab.id // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
      ,
      analytics: (analytics === null || analytics === void 0 ? void 0 : analytics.tabProps) || (analytics === null || analytics === void 0 ? void 0 : analytics.enabled) && analytics // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
      ,
      enableAnalytics: enableAnalytics || (analytics === null || analytics === void 0 ? void 0 : analytics.enabled),
      label: tab.label
    }, tab.initialActiveTab ? /*#__PURE__*/React.createElement(ExpandableContent, {
      analytics: (analytics === null || analytics === void 0 ? void 0 : analytics.expandableContentProps) || analytics // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
      ,
      enableAnalytics: enableAnalytics || (analytics === null || analytics === void 0 ? void 0 : analytics.enabled),
      id: tab.id,
      omitExpandFunctionalityOnMobile: omitExpandFunctionalityOnMobile,
      contentExpandedOnInitialization: initTabContentExpanded,
      trkSectionCategory: "".concat(TRK_PRODUCT_LOCATION, "__tabs--").concat(id),
      trkSectionPosition: trkSectionPosition
    }, /*#__PURE__*/React.createElement(TabContentImpression, {
      analytics: (analytics === null || analytics === void 0 ? void 0 : analytics.tabContentProps) || analytics // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
      ,
      enableAnalytics: enableAnalytics || (analytics === null || analytics === void 0 ? void 0 : analytics.enabled),
      hasReviewLink: tab.hasReviewLink,
      marketplaceEntity: marketplaceEntity,
      tabId: tab.id,
      taxonomy: taxonomy,
      trkPageType: trkPageType,
      trkSectionCategory: trkSectionCategory
    }, sanitizeNode(tab.content))) : /*#__PURE__*/React.createElement(TabContentImpression, {
      analytics: (analytics === null || analytics === void 0 ? void 0 : analytics.tabContentProps) || analytics // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
      ,
      enableAnalytics: enableAnalytics || (analytics === null || analytics === void 0 ? void 0 : analytics.enabled),
      hasReviewLink: tab.hasReviewLink,
      marketplaceEntity: marketplaceEntity,
      tabId: tab.id,
      taxonomy: taxonomy,
      trkPageType: trkPageType,
      trkSectionCategory: trkSectionCategory
    }, sanitizeNode(tab.content)));
  }));
};

Content.propTypes = {
  activeContentTab: PropTypes.oneOf(_values(CONTENT_TABS)),
  bottomLine: PropTypes.node,
  className: PropTypes.string,
  cons: PropTypes.node,
  id: PropTypes.string,
  initTabContentExpanded: PropTypes.bool,
  keyFacts: PropTypes.node,
  marketplaceEntity: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  omitExpandFunctionalityOnMobile: PropTypes.bool,
  omittedTabs: PropTypes.arrayOf(PropTypes.oneOf(_values(CONTENT_TABS))),
  productDetails: PropTypes.node,
  pros: PropTypes.node,
  reviewLinkTabIndex: PropTypes.number,
  taxonomy: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  trkPageType: PropTypes.string,
  trkSectionCategory: PropTypes.string,
  trkSectionPosition: PropTypes.number,
  // bedrock props
  analytics: PropTypes.shape({
    expandableContentProps: PropTypes.shape({
      entityName: PropTypes.string
    }),
    tabContentProps: TabContentImpression.propTypes.analytics,
    tabProps: TabImpression.propTypes.analytics
  }),
  enableAnalytics: PropTypes.bool,
  parentImpressionId: PropTypes.string
};
Content.defaultProps = {
  activeContentTab: _values(CONTENT_TABS)[0],
  initTabContentExpanded: false,
  omitExpandFunctionalityOnMobile: false,
  reviewLinkTabIndex: 1,
  // bedrock default props
  analytics: {}
};
export default Content;